"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _AaPassengerRoomSelectionPopup = _interopRequireDefault(require("./AaPassengerRoomSelection-Popup.component"));

var _AaPassengerRoomSelection = require("./AaPassengerRoomSelection.model");

var _AaPassengerRoomSelection2 = _interopRequireDefault(require("./AaPassengerRoomSelection.styles"));

var _TextSummary = _interopRequireDefault(require("./TextSummary"));

var _InputSummary = _interopRequireDefault(require("./InputSummary"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AaPassengerRoomSelection = function AaPassengerRoomSelection(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];
  /**
   *
   * @param {boolean} val
   *
   * Determines if passenger will be open or not
   */


  var toggleModal = function toggleModal(val) {
    setIsModalOpen(val);

    if (props.controls.onFocus) {
      props.controls.onFocus(val);
    }
  };

  var updatePassengerCount = function updatePassengerCount(paxCount) {
    props.controls.onUpdate(paxCount);
  };

  var popupConfig = {
    controls: {
      onBackdropClose: toggleModal,
      onChangeData: updatePassengerCount,
      max: props.controls.max,
      min: props.controls.min,
      openModal: isModalOpen,
      isMobilePlatform: props.controls.isMobilePlatform,
      isMobileLayout: props.controls.isMobileLayout,
      isLeftAligned: props.controls.isLeftAligned,
      enableMultipleRooms: props.controls.enableMultipleRooms
    },
    data: props.data,
    ageList: props.ageList
  };
  var containerStyle = props.controls.showResultAsInput ? {} : _AaPassengerRoomSelection2["default"].passengerSelectionContainer;
  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: containerStyle
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, (0, _extends2["default"])({
    accessibilityRole: "button",
    style: _AaPassengerRoomSelection2["default"].touchable,
    onPress: function onPress() {
      return toggleModal(true);
    }
  }, props.controls.otherTouchableOpacityProps), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: {
      flexDirection: 'row'
    }
  }, props.controls.showResultAsInput ? /*#__PURE__*/_react["default"].createElement(_InputSummary["default"], {
    data: props.data,
    translation: props.translation
  }) : /*#__PURE__*/_react["default"].createElement(_TextSummary["default"], {
    translation: props.translation,
    data: props.data
  }))), isModalOpen ? /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelectionPopup["default"], {
    controls: popupConfig.controls,
    data: popupConfig.data,
    translation: props.translation,
    ageList: popupConfig.ageList
  }) : null);
};

var _default = AaPassengerRoomSelection;
exports["default"] = _default;